// Shared DOM ids wiring the header hamburger (disclosure trigger) to the drawer region it controls.
export const MOBILE_DRAWER_ID = 'site-mobile-drawer'
export const HEADER_HAMBURGER_ID = 'site-header-hamburger'
